import React from "react";
import ReactSelect from "react-select";
import { withQuery } from "containers/withQuery";
import { FORMULAS_QUERY } from "../../graphql/queries/get/gqlSelectQueries";

const Select = ({
  value,
  onChange,
  concreteFormulas,
}) => (
  concreteFormulas
    ? (
      <div style={{
        width: "100%",
        fontWeight: "bold",
      }}
      >
        <ReactSelect
          className="react-select dark"
          classNamePrefix="react-select"
          name="itemSelected"
          value={value}
          onChange={onChange}
          options={[
            {
              value: "",
              isDisabled: true
            },
            ...concreteFormulas.map(({
              id,
              code,
              fck,
              concreteFamily: {
                slump: {
                  description
                }
              }
            }) => ({
              value: id,
              code,
              label: `Cód. ${code} | FCK ${fck} | Slump ${description}`,
            }))
          ]}
          placeholder="Escolha..."
        />
      </div>
    ) : null);

export default withQuery({
  query: FORMULAS_QUERY
})(Select);
